import React from 'react';
import _ from 'underscore';
import {
  withGoogleMap,
  GoogleMap,
  Marker,
  Polygon,
} from 'react-google-maps';

const { DrawingManager } = require("react-google-maps/lib/components/drawing/DrawingManager");

// Weird Function for parsing Google Maps polygon Lats & Longs
const parsePolygon = (poly) => {
  const paths = [];
  poly.getPath().getArray().forEach((point) => {
    paths.push([point.lng(), point.lat()]);
  });
  return paths;
};

// Not used, but leaving this here for reference
const testPoly =
  new google.maps.Polygon(
  [{"lng":-118.41983493213331,"lat":33.993194711141115},
  {"lng":-118.4052437150923,"lat":33.98180793775189},
  {"lng":-118.43004878406202,"lat":33.980953868245834}]
  );

const green = '#21B88E';
const blue = '#1384D2';

const staticPolygonOptions = {
  strokeColor: green,
  fillColor: green,
  fillOpacity: .6,
  strokeWeight: 2,
  zIndex: 1,
}

const dynamicPolygonOptions = {
  strokeColor: green,
  fillColor: green,
  fillOpacity: .4,
  strokeWeight: 3,
  zIndex: 1,
}

// Focus on one polygon out of many, such as creating or editing a market.
const focusPolygonOptions = {
  strokeColor: blue,
  fillColor: blue,
  fillOpacity: .4,
  strokeWeight: 3,
  zIndex: 1,
}


const Map = withGoogleMap((props) => {
  const onPolygonComplete = (polygon) => {
    const coordinates = parsePolygon(polygon);
    // Complete the polygon loop
    coordinates.push(coordinates[0]);

    return props.onPolygonComplete({
      type: 'Polygon',
      coordinates: [[[coordinates]]],
      polygon,
    });
  };

  const drawingColor = props.focusLatLongs ? blue : green;

  return (
    <div>
      <GoogleMap
        defaultZoom={props.zoom ? props.zoom : 14}
        defaultCenter={props.location}
        defaultOptions={{ mapTypeControl: false, streetViewControl: false, fullscreenControl: false }}
        zoom={props.zoom ? props.zoom : 14}
        center={props.location}
        onClick={event => props.onMapClick(event.latLng.lat(), event.latLng.lng())}
      >
        <DrawingManager
          onPolygonComplete={(polygon) => onPolygonComplete(polygon)}
          defaultOptions={{
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: [
                google.maps.drawing.OverlayType.POLYGON,
              ],
            },
            polygonOptions: {
              draggable: true,
              strokeColor: drawingColor,
              fillColor: drawingColor,
              fillOpacity: .4,
              strokeWeight: 3,
              clickable: true,
              editable: true,
              zIndex: 1,
            },
          }}
        />
        {props.showMarker &&
        <Marker
          position={props.location}
          draggable
          onDrag={event => props.onLocationDrag(event.latLng.lat(), event.latLng.lng())}
        />}
        {!_.isEmpty(props.latLongs) && props.latLongs.map((fence) =>
          (
            <Polygon
              key={fence[0].lng}
              options={props.canEditPolygon ? dynamicPolygonOptions : staticPolygonOptions}
              path={fence}
            />
          ))}
        {!_.isEmpty(props.focusLatLongs) && props.focusLatLongs.map((fence) =>
          (
            <Polygon
              key={fence[0].lng}
              options={focusPolygonOptions}
              path={fence}
            />
          ))}
      </GoogleMap>
    </div>
  );
});


export default class GeofenceMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.location,
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({location: newProps.location});
  }

  render() {
		return (
			<div>
        {this.state.location &&
        <Map
          onPolygonComplete={this.props.onPolygonComplete}
          location={this.state.location}
          containerElement={<div style={{ height: this.props.height || 500 }} />}
          mapElement={<div style={{ height: `100%` }} />}
          visible={true}
          onLocationDrag={this.props.onLocationDrag}
          onMapClick={() => {}}
          latLongs={this.props.latLongs}
          focusLatLongs={this.props.focusLatLongs}
          zoom={this.props.zoom}
          showMarker={this.props.showMarker}
          canEditPolygon={this.props.canEditPolygon}
        />}
      </div>
		);
	}
}
